export default __webpack_public_path__ + "b20de35fde75778efb2c4a71d4230b2b.png";